import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink, FiShoppingBag } = FiIcons;

export default function Footer() {
  return (
    <div className="mt-12 w-full max-w-5xl text-center flex flex-col items-center px-4">
      {/* Royal Star Advertisement */}
      <a 
        href="https://royalstar.co.in/s/0e0621" 
        target="_blank" 
        rel="noopener noreferrer"
        className="group w-full max-w-3xl mb-10 overflow-hidden relative"
      >
        <div className="bg-gradient-to-r from-blue-700 via-blue-600 to-indigo-700 p-[1px] rounded-2xl shadow-xl shadow-blue-600/20 transition-all duration-300 group-hover:shadow-blue-600/40 group-hover:-translate-y-1">
          <div className="bg-white rounded-[15px] overflow-hidden flex flex-col sm:flex-row items-center">
            {/* Ad Image/Icon Section */}
            <div className="w-full sm:w-1/3 bg-slate-50 h-32 sm:h-auto flex items-center justify-center relative overflow-hidden">
               <div className="absolute inset-0 bg-blue-600/5 group-hover:bg-blue-600/0 transition-colors"></div>
               <SafeIcon icon={FiShoppingBag} className="text-5xl text-blue-600 relative z-10" />
            </div>
            
            {/* Ad Content Section */}
            <div className="flex-1 p-6 text-left">
              <div className="flex items-center justify-between mb-2">
                <span className="text-[10px] font-black uppercase tracking-[0.2em] text-blue-600 bg-blue-50 px-2 py-1 rounded">Sponsored</span>
                <SafeIcon icon={FiExternalLink} className="text-slate-300 group-hover:text-blue-500 transition-colors" />
              </div>
              <h4 className="text-xl font-bold text-slate-900 group-hover:text-blue-600 transition-colors">Royal Star</h4>
              <p className="text-sm text-slate-500 mt-1 leading-relaxed">
                Explore high-quality anti-yellow MagSafe back covers, tempered glass, membranes, mobile camera lenses, etc.
              </p>
              <div className="mt-4 inline-flex items-center text-sm font-bold text-blue-600">
                Explore Now
                <span className="ml-2 transform transition-transform group-hover:translate-x-1">→</span>
              </div>
            </div>
          </div>
        </div>
      </a>
      
      <p className="text-xs text-slate-400 font-medium">
        &copy; {new Date().getFullYear()} ShipAssure. All rights reserved.
      </p>
      <p className="text-[10px] text-slate-300 mt-2 uppercase tracking-widest">
        Powered by ShareMyImage.com
      </p>
    </div>
  );
}